import bus from '@/utils/bus';

import { getOptionRulesWithNote } from '@/utils/helper';

export default {
  name: 'MenuItemOptionsSelector',
  props: {
    options: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      selectedIndexes: [],
      show: false,
    };
  },
  created() {
    bus.$on('CLOSE_OPTIONS_SELECTOR', () => {
      this.show = false;
      this.selectedIndexes = [];
    });
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  methods: {
    getOptionRulesWithNote,
    onAddOptions() {
      bus.$emit('SET_ENTREE_OPTIONS', this.selectedIndexes);
      this.selectedIndexes = [];
    },
  },
};
